export function chunkArray(array, sizes = []) {
	const size = sizes.length ? sizes.shift() : array.length;
	if (array.length <= size) {
		return [array];
	}
	return [array.slice(0, size), ...chunkArray(array.slice(size), sizes)];
}
